function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-4ad9469e\",\"scoped\":true,\"hasInlineConfig\":false}!resolve-url-loader?sourceMap!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./menu.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./menu.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4ad9469e\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./menu.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ad9469e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./app/components/frame/menu.vue
// module id = 644
// module chunks = 30